import { render, staticRenderFns } from "./ProxyPackagesPage.vue?vue&type=template&id=0149cbc1"
import script from "./ProxyPackagesPage.vue?vue&type=script&lang=js"
export * from "./ProxyPackagesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports